'use strict';

import React, { useMemo } from "react";
import { formatCurrency } from "../../../../common/CartHelpers";

export default function CartItem({ item, handleIncrement, handleDecrement }) {
  const { nsProductId, nid, name, icon, unitPrice, quantity } = item;
  const cartPrice = useMemo(() => {
    return unitPrice * quantity;
  }, [item]);

  const handleDecrementClick = () => {
    handleDecrement(item);
  };

  const handleIncrementClick = () => {
    handleIncrement(item);
  };

  return (
    <div className="cart-item">
      <div className="cart-item__icon">
        <img src={icon} className="cart-item__icon--icon" />


      </div>
      <div className="cart-item__name-quantity">
        <span>{name}</span>
        <div className="quantity">
          <button onClick={handleDecrementClick}>
            {quantity === 1 && (
              <span><i className="cart-icon fa-solid fa-trash"></i></span>
            )}
            {quantity > 1 && (
              <span><i className="cart-icon fa-solid fa-minus"></i></span>
            )}
          </button>
          <span className="quantity-number">{quantity}</span>
          <button onClick={handleIncrementClick}>
            <span><i className="cart-icon fa-solid fa-plus"></i></span>
          </button>
        </div>
      </div>
      <div className="cart-item__price">
        <span>${formatCurrency(cartPrice)}</span>
      </div>
    </div>
  )
}
